const html = `<div class='editor__page'>
<h1>Heading 1</h1>
<h2>Heading 2</h2>
<h2>Heading 2</h2>
<h3>Heading 3</h3>
<h3>Heading 3</h3>
<h1>Heading 1</h1>
<h2>Heading 2</h2>
<h3>Heading 3</h3>
<p>Paragraph</p>
<p>Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Donec rutrum congue leo eget malesuada. Donec sollicitudin molestie malesuada. Proin eget tortor risus. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. Nulla quis lorem ut libero malesuada feugiat. Nulla porttitor accumsan tincidunt.
Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. Sed porttitor lectus nibh. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Donec sollicitudin molestie malesuada. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Donec sollicitudin molestie malesuada. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula.</p>
<table style="min-width: 100px;">
<colgroup>
<col style="min-width: 25px;">
<col style="min-width: 25px;">
<col style="min-width: 25px;">
<col style="min-width: 25px;">
</colgroup>
<tbody>
<tr>
<th colspan="1" rowspan="1">
<p>Header</p>
</th>
<th colspan="1" rowspan="1">
<p>Header</p>
</th>
<th colspan="1" rowspan="1">
<p>Header</p>
</th>
<th colspan="1" rowspan="1">
<p>Header</p>
</th>
</tr>
<tr>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
</tr>
<tr>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
</tr>
<tr>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
<td colspan="1" rowspan="1">
<p>Cell</p>
</td>
</tr>
</tbody>
</table>
</div>
`;

export default html
